import {
  CANCEL_HOST,
  CANCEL_HOST_IS_ERROR,
  CANCEL_HOST_IS_PENDING,
  FETCH_ALERTS,
  FETCH_ALERTS_IS_ERROR,
  FETCH_ALERTS_IS_PENDING,
  FETCH_BMC_STATUS,
  FETCH_BMC_STATUS_IS_ERROR,
  FETCH_BMC_STATUS_IS_PENDING,
  FETCH_HOSTS,
  FETCH_HOSTS_BY_ID,
  FETCH_HOSTS_BY_ID_IS_ERROR,
  FETCH_HOSTS_BY_ID_IS_PENDING,
  FETCH_HOSTS_INSTANCE_TYPES,
  FETCH_HOSTS_INSTANCE_TYPES_IS_ERROR,
  FETCH_HOSTS_INSTANCE_TYPES_IS_PENDING,
  FETCH_HOSTS_IS_ERROR,
  FETCH_HOSTS_IS_PENDING,
  FETCH_INVOICES,
  FETCH_INVOICES_IS_ERROR,
  FETCH_INVOICES_IS_PENDING,
  FILTER_HOSTS,
  RESET_REDUCER,
  RESTART_HOST,
  RESTART_HOST_IS_ERROR,
  RESTART_HOST_IS_PENDING,
  REVERT_CANCEL_HOST,
  REVERT_CANCEL_HOST_IS_ERROR,
  REVERT_CANCEL_HOST_IS_PENDING,
  SET_RDNS_HOST_NAME,
  SET_RDNS_HOST_NAME_IS_ERROR,
  SET_RDNS_HOST_NAME_IS_PENDING,
  SORT_HOSTS,
  START_HOST,
  START_HOST_IS_ERROR,
  START_HOST_IS_PENDING,
  STOP_HOST,
  STOP_HOST_IS_ERROR,
  STOP_HOST_IS_PENDING,
  UPDATE_HOST,
  UPDATE_HOST_IS_ERROR,
  UPDATE_HOST_IS_PENDING,
} from 'services/Hosts/types';
import { sort } from 'utils/functions';

const INITIAL_STATE = {
  hosts: [],
  filterBy: 'SHOW_ALL',
  sortBy: 'id',
  sortDirection: 'ASC',
  params: {},
  host: {},
  fetchIsCompleted: false,
  fetchIsPending: false,
  fetchIsError: null,
  fetchByIdIsCompleted: false,
  fetchByIdIsPending: false,
  fetchByIdIsError: null,
  updateHostIsCompleted: true,
  updateHostIsPending: false,
  updateHostIsError: null,
  instanceTypes: [],
  fetchInstaceTypesIsCompleted: false,
  fetchInstaceTypesIsPending: false,
  fetchInstaceTypesIsError: null,
  startHostIsCompleted: false,
  startHostIsPending: false,
  startHostIsError: null,
  stopHostIsCompleted: false,
  stopHostIsPending: false,
  stopHostIsError: null,
  restartHostIsCompleted: false,
  restartHostIsPending: false,
  restartHostIsError: null,
  setRDNSIsCompleted: false,
  setRDNSIsPending: false,
  setRDNSIsError: null,
  cancelIsCompleted: false,
  cancelIsPending: false,
  cancelIsError: null,
  revertCancelIsCompleted: false,
  revertCancelIsPending: false,
  revertCancelIsError: null,
  fetchInvoiceIsCompleted: false,
  fetchInvoiceIsPending: false,
  fetchInvoiceIsError: null,
  alerts: [],
  fetchAlertsIsCompleted: false,
  fetchAlertsIsPending: false,
  fetchAlertsIsError: null,
  fetchBmcStatusIsCompleted: false,
  fetchBmcStatusIsPending: false,
  fetchBmcStatusIsError: null,
};

const hostsReducer = (
  state = {
    ...INITIAL_STATE,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case FETCH_HOSTS:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        hosts: sort(action.data, {
          sortBy: state.sortBy,
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortDirection: state.sortDirection,
          sortSearchValue: (state.params as $TSFixMe).sortSearchValue || (state.params as $TSFixMe).value || null,
        }),
        fetchIsCompleted: true,
        fetchIsPending: false,
        fetchIsError: null,
      };
    case FETCH_HOSTS_IS_PENDING:
      return {
        ...state,
        fetchIsCompleted: false,
        fetchIsPending: true,
        fetchIsError: null,
      };
    case FETCH_HOSTS_IS_ERROR:
      return {
        ...state,
        fetchIsCompleted: true,
        fetchIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchIsError: action.error,
      };
    case FETCH_HOSTS_BY_ID:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        host: action.data,
        fetchByIdIsCompleted: true,
        fetchByIdIsPending: false,
        fetchByIdIsError: null,
      };
    case FETCH_HOSTS_BY_ID_IS_PENDING:
      return {
        ...state,
        fetchByIdIsCompleted: false,
        fetchByIdIsPending: true,
        fetchByIdIsError: null,
      };
    case FETCH_HOSTS_BY_ID_IS_ERROR:
      return {
        ...state,
        fetchByIdIsCompleted: true,
        fetchByIdIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchByIdIsError: action.error,
      };
    case UPDATE_HOST:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        host: action.data,
        updateHostIsCompleted: true,
        updateHostIsPending: false,
        updateHostIsError: null,
      };
    case UPDATE_HOST_IS_PENDING:
      return {
        ...state,
        updateHostIsCompleted: false,
        updateHostIsPending: true,
        updateHostIsError: null,
      };
    case UPDATE_HOST_IS_ERROR:
      return {
        ...state,
        updateHostIsCompleted: true,
        updateHostIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        updateHostIsError: action.error,
      };
    case FETCH_HOSTS_INSTANCE_TYPES:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        instanceTypes: action.data,
        fetchInstaceTypesIsCompleted: true,
        fetchInstaceTypesIsPending: false,
        fetchInstaceTypesIsError: null,
      };
    case FETCH_HOSTS_INSTANCE_TYPES_IS_PENDING:
      return {
        ...state,
        fetchInstaceTypesIsCompleted: false,
        fetchInstaceTypesIsPending: true,
        fetchInstaceTypesIsError: null,
      };
    case FETCH_HOSTS_INSTANCE_TYPES_IS_ERROR:
      return {
        ...state,
        fetchInstaceTypesIsCompleted: true,
        fetchInstaceTypesIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchInstaceTypesIsError: action.error,
      };
    case FILTER_HOSTS:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        filterBy: action.filterBy,
      };
    case SORT_HOSTS:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        params: action.params,
        hosts: sort(state.hosts, {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };
    case START_HOST:
      return {
        ...state,
        startHostIsCompleted: true,
        startHostIsPending: null,
        startHostIsError: null,
      };
    case START_HOST_IS_PENDING:
      return {
        ...state,
        startHostIsCompleted: false,
        startHostIsPending: true,
        startHostIsError: null,
      };
    case START_HOST_IS_ERROR:
      return {
        ...state,
        startHostIsCompleted: true,
        startHostIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        startHostIsError: action.error,
      };
    case STOP_HOST:
      return {
        ...state,
        stopHostIsCompleted: true,
        stopHostIsPending: false,
        stopHostIsError: null,
      };
    case STOP_HOST_IS_PENDING:
      return {
        ...state,
        stopHostIsCompleted: false,
        stopHostIsPending: true,
        stopHostIsError: null,
      };
    case STOP_HOST_IS_ERROR:
      return {
        ...state,
        stopHostIsCompleted: true,
        stopHostIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        stopHostIsError: action.error,
      };
    case RESTART_HOST:
      return {
        ...state,
        restartHostIsCompleted: true,
        restartHostIsPending: null,
        restartHostIsError: null,
      };
    case RESTART_HOST_IS_PENDING:
      return {
        ...state,
        restartHostIsCompleted: false,
        restartHostIsPending: true,
        restartHostIsError: null,
      };
    case RESTART_HOST_IS_ERROR:
      return {
        ...state,
        restartHostIsCompleted: true,
        restartHostIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        restartHostIsError: action.error,
      };
    case SET_RDNS_HOST_NAME:
      return {
        ...state,
        setRDNSIsCompleted: true,
        setRDNSIsPending: false,
        setRDNSIsError: null,
      };
    case SET_RDNS_HOST_NAME_IS_PENDING:
      return {
        ...state,
        setRDNSIsCompleted: false,
        setRDNSIsPending: true,
        setRDNSIsError: null,
      };
    case SET_RDNS_HOST_NAME_IS_ERROR:
      return {
        ...state,
        setRDNSIsCompleted: true,
        setRDNSIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        setRDNSIsError: action.error,
      };
    case CANCEL_HOST:
      return {
        ...state,
        cancelIsCompleted: true,
        cancelIsPending: false,
        cancelIsError: null,
      };
    case CANCEL_HOST_IS_PENDING:
      return {
        ...state,
        cancelIsCompleted: false,
        cancelIsPending: true,
        cancelIsError: null,
      };
    case CANCEL_HOST_IS_ERROR:
      return {
        ...state,
        cancelIsCompleted: true,
        cancelIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        cancelIsError: action.error,
      };
    case REVERT_CANCEL_HOST:
      return {
        ...state,
        revertCancelIsCompleted: true,
        revertCancelIsPending: false,
        revertCancelIsError: null,
      };
    case REVERT_CANCEL_HOST_IS_PENDING:
      return {
        ...state,
        revertCancelIsCompleted: false,
        revertCancelIsPending: true,
        revertCancelIsError: null,
      };
    case REVERT_CANCEL_HOST_IS_ERROR:
      return {
        ...state,
        revertCancelIsCompleted: true,
        revertCancelIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        revertCancelIsError: action.error,
      };
    case FETCH_INVOICES:
      return {
        ...state,
        fetchInvoiceIsCompleted: true,
        fetchInvoiceIsPending: false,
        fetchInvoiceIsError: null,
      };
    case FETCH_INVOICES_IS_PENDING:
      return {
        ...state,
        fetchInvoiceIsCompleted: false,
        fetchInvoiceIsPending: true,
        fetchInvoiceIsError: null,
      };
    case FETCH_INVOICES_IS_ERROR:
      return {
        ...state,
        fetchInvoiceIsCompleted: true,
        fetchInvoiceIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchInvoiceIsError: action.error,
      };
    case FETCH_ALERTS:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        alerts: action.data,
        fetchAlertsIsCompleted: true,
        fetchAlertsIsPending: false,
        fetchAlertsIsError: null,
      };
    case FETCH_ALERTS_IS_PENDING:
      return {
        ...state,
        fetchAlertsIsCompleted: false,
        fetchAlertsIsPending: true,
        fetchAlertsIsError: null,
      };
    case FETCH_ALERTS_IS_ERROR:
      return {
        ...state,
        fetchAlertsIsCompleted: true,
        fetchAlertsIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchAlertsIsError: action.error,
      };
    case FETCH_BMC_STATUS:
      return {
        ...state,
        fetchBmcStatusIsCompleted: true,
        fetchBmcStatusIsPending: false,
        fetchBmcStatusIsError: null,
      };
    case FETCH_BMC_STATUS_IS_PENDING:
      return {
        ...state,
        fetchBmcStatusIsCompleted: false,
        fetchBmcStatusIsPending: true,
        fetchBmcStatusIsError: null,
      };
    case FETCH_BMC_STATUS_IS_ERROR:
      return {
        ...state,
        fetchBmcStatusIsCompleted: true,
        fetchBmcStatusIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchBmcStatusIsError: action?.error,
      };
    case RESET_REDUCER:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export default hostsReducer;
